import { z } from "zod";

import { createQueryRequestDefinition } from "~/lib/network/definitions/create";

import {
  clientExportAnalysisResponseSchema,
  jerboaClientExportDetailResponseSchema,
  jerboaClientExportStatusSchema,
  jerboaClientExportsListResponseSchema,
} from "./schemas";

export const fetchJerboaClientExportsQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "jerboa-client-exports", "list"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/jerboa-client-exports",
  paramsSchema: z.object({
    afterCursor: z.string().nullable().optional().default(null),
    pageSize: z.number().max(50).optional().default(20),
    status: jerboaClientExportStatusSchema.optional(),
    projectId: z.string().optional(),
  }),
  responseSchema: jerboaClientExportsListResponseSchema,
}).withPagination({
  getNextPageParam(lastPage) {
    return lastPage.pageInfo.hasNextPage ? lastPage.pageInfo.endCursor : undefined;
  },
  mapPaginationParamsToQueryParams({ pageParam }) {
    return {
      ...(pageParam ? { afterCursor: pageParam } : {}),
      pageSize: 20,
    };
  },
});

export const getJerboaClientExportQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "jerboa-client-exports", "detail"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/jerboa-client-exports/:id",
  responseSchema: jerboaClientExportDetailResponseSchema,
});

export const fetchJerboaClientExportAnalysisQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "jerboa-client-exports", "analysis"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/jerboa-client-exports/analysis",
  paramsSchema: z.object({
    days: z.number().min(1).max(90).default(7),
  }),
  responseSchema: clientExportAnalysisResponseSchema,
});
